import { contactInfo, navLinks } from "../data/mock";
import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToSection } from "../lib/scroll";

const LOGO_URL = "https://customer-assets-0z36b82j.emergentagent.net/job_chauffeur-prive-29/artifacts/ebdff0165cb41c3c_Van%20D%27Iroise.jpg";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleNavClick = (e, href) => {
    e.preventDefault();
    scrollToSection(href);
  };

  return (
    <footer data-testid="main-footer" className="relative bg-[#12141f] pt-10 pb-16 md:pb-20 overflow-hidden">
      {/* Massive watermark */}
      <div className="overflow-hidden select-none pointer-events-none mb-10 md:mb-14" aria-hidden="true">
        <p
          className="text-[13.5vw] leading-[0.85] text-white/[0.045] text-center whitespace-nowrap tracking-tight font-medium"
          style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
        >
          VAN D'IROISE
        </p>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-20 mb-16">
          {/* Brand */}
          <div>
            <img
              src={LOGO_URL}
              alt="Van d'Iroise"
              className="h-[52px] w-auto object-contain mb-6"
            />
            <p className="text-[14px] text-white/40 leading-[1.7] max-w-[280px]">
              Service de chauffeur privé haut de gamme à Brest et dans tout le Finistère. Van Mercedes Classe V, 7 places.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-[12px] tracking-[0.2em] uppercase text-[#c9a84c]/60 mb-6">
              Navigation
            </h4>
            <nav className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  data-testid={`footer-nav-${link.label.toLowerCase()}`}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-[14px] text-white/50 hover:text-[#c9a84c] transition-colors duration-200"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[12px] tracking-[0.2em] uppercase text-[#c9a84c]/60 mb-6">
              Contact
            </h4>
            <div className="space-y-4">
              <a
                data-testid="footer-phone-link"
                href={contactInfo.phoneLink}
                className="flex items-center gap-3 text-[14px] text-white/50 hover:text-[#c9a84c] transition-colors duration-200"
              >
                <Phone size={16} strokeWidth={1.5} className="text-[#c9a84c]/60" />
                {contactInfo.phone}
              </a>
              <a
                data-testid="footer-email-link"
                href={contactInfo.emailLink}
                className="flex items-center gap-3 text-[14px] text-white/50 hover:text-[#c9a84c] transition-colors duration-200 break-all"
              >
                <Mail size={16} strokeWidth={1.5} className="flex-shrink-0 text-[#c9a84c]/60" />
                {contactInfo.email}
              </a>
              <div className="flex items-center gap-3 text-[14px] text-white/50">
                <MapPin size={16} strokeWidth={1.5} className="flex-shrink-0 text-[#c9a84c]/60" />
                {contactInfo.location}
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[12px] text-white/20">
            © {currentYear} Van d'Iroise — Chauffeur privé. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <Link
              data-testid="footer-mentions-legales"
              to="/mentions-legales"
              className="text-[12px] text-white/30 hover:text-[#c9a84c] transition-colors duration-200"
            >
              Mentions légales
            </Link>
            <Link
              data-testid="footer-politique-confidentialite"
              to="/politique-de-confidentialite"
              className="text-[12px] text-white/30 hover:text-[#c9a84c] transition-colors duration-200"
            >
              Politique de confidentialité
            </Link>
            <p className="text-[12px] text-white/20">
              Disponible 24/7 — Brest & Finistère (29)
            </p>
          </div>
        </div>

        {/* Conception */}
        <div className="border-t border-white/5 mt-6 pt-6 flex justify-center">
          <a
            data-testid="footer-credit-driveflow"
            href="https://www.driveflowtechnologies.fr/web"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 opacity-60 hover:opacity-90 transition-opacity duration-300"
          >
            <span className="text-[11px] text-white/50">
              Conception par
            </span>
            <span className="text-[13px] font-semibold">
              <span className="text-white">Drive</span>
              <span className="text-[#4B83F0]">Flow</span>
              <span className="text-white ml-1">Web</span>
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
};
